export const IS_SEND_ENTER_VARIANT_LOCALSTORAGE_KEY = 'is-send-enter-variant';
